import { createApp } from 'vue'
import App from './App.vue'
import router from "./router";
import "bootstrap/dist/css/bootstrap.min.css";
import 'vue3-toastify/dist/index.css';

const app = createApp(App);
app.use(router);
app.mount("#app");
